module.exports = __webpack_public_path__ + "img/paper-plane-white.4845232e.svg";